import React from 'react';
import { 
  FaHandshake,
  FaUsers,
  FaGraduationCap,
  FaGlobe,
  FaComments,
  FaPhoneAlt,
  FaBullseye,
  FaBriefcase,
  FaHome,
  FaHeartbeat,
  FaCrown,
  FaSearch,
  FaPalette,
  FaChartLine,
  FaUniversity,
  FaRocket,
  FaCheck
} from 'react-icons/fa';
import { 
  FiMessageCircle,
  FiTarget,
  FiUser,
  FiFileText,
  FiShield,
  FiClipboard,
  FiTrendingUp,
  FiMapPin,
  FiBook,
  FiAward
} from 'react-icons/fi';
import './EcoleUnivFrancaise.css';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const EcoleUnivFrancaise = () => {
  const serviceCategories = [
    {
      icon: <FiTarget />,
      title: 'Développement du recrutement international',
      description: 'Nous aidons les établissements français à renforcer leur attractivité internationale',
      services: [
        { icon: <FaGlobe />, text: 'Mise en relation avec des écoles et universités africaines partenaires' },
        { icon: <FaGraduationCap />, text: 'Création et pilotage de programmes de mobilité, double diplôme, co-diplômation' },
        { icon: <FaUsers />, text: 'Campagnes de recrutement ciblées en Afrique' },
        { icon: <FiUser />, text: 'Sélection de profils qualifiés et adaptés aux exigences académiques' },
        { icon: <FaBriefcase />, text: 'Organisation de salons de recrutement et d\'évènements Afrique → France' }
      ]
    },
    {
      icon: <FaHandshake />,
      title: 'Développement de partenariats stratégiques',
      description: 'Renforcement de la présence sur le continent africain',
      services: [
        { icon: <FiFileText />, text: 'Accompagnement complet pour signer des accords académiques' },
        { icon: <FaGraduationCap />, text: 'Construction de programmes co-construits' },
        { icon: <FiMapPin />, text: 'Renforcement de la présence de l\'établissement sur le continent africain' },
        { icon: <FaHandshake />, text: 'Développement de réseaux institutionnels durables' }
      ]
    },
    {
      icon: <FaUsers />,
      title: 'Accompagnement et intégration des étudiants étrangers',
      description: 'Service PREMIUM pour écoles françaises',
      services: [
        { icon: <FiUser />, text: 'Aide à la recherche de job étudiant' },
        { icon: <FaBriefcase />, text: 'Recherche de stage et d\'alternance (avec réseau d\'entreprises partenaires)' },
        { icon: <FiShield />, text: 'Accompagnement au renouvellement du titre de séjour' },
        { icon: <FiClipboard />, text: 'Assistance juridique liée au statut étudiant étranger' },
        { icon: <FiFileText />, text: 'Suivi social et administratif' },
        { icon: <FaHome />, text: 'Ateliers d\'intégration (logement, banque, sécurité sociale, transport, etc.)' },
        { icon: <FaHeartbeat />, text: 'Soutien à la santé mentale & bien-être étudiant' },
        { icon: <FiBook />, text: 'Orientation en cas de réorientation académique ou difficultés scolaires' }
      ]
    }
  ];

  const contacts = [
    { 
      name: 'Marie Claude', 
      phone: '+33 7 49 91 11 12', 
      role: 'Responsable Partenariats',
      icon: <FaHandshake />
    },
    { 
      name: 'Kevin', 
      phone: '+33 6 51 59 56 03', 
      role: 'Responsable Recrutement International',
      icon: <FaGlobe />
    }
  ];

  const createWhatsAppLink = (phone, name) => {
    const message = `Bonjour ${name}, je suis intéressé(e) par vos services pour les établissements français.`;
    return `https://wa.me/${phone.replace(/\s/g, '')}?text=${encodeURIComponent(message)}`;
  };

  return (
    <section className="fr-school-sectionbigcontain">
        <Header />
    <section className="fr-school-section">
              
      <div className="fr-school-canvas">
        <div className="fr-school-decoration">
          {/* Étoiles françaises */}
          <div className="fr-star fr-star-1"></div>
          <div className="fr-star fr-star-2"></div>
          <div className="fr-star fr-star-3"></div>
          <div className="fr-star fr-star-4"></div>
          
          {/* Lignes élégantes */}
          <div className="fr-elegant-line fr-line-1"></div>
          <div className="fr-elegant-line fr-line-2"></div>
          
          {/* Orbes français */}
          <div className="fr-glow-orb fr-orb-1"></div>
          <div className="fr-glow-orb fr-orb-2"></div>
          <div className="fr-glow-orb fr-orb-3"></div>
        </div>
      </div>

      <div className="fr-school-wrapper">
        <div className="fr-school-header">
          <h1 className="fr-school-title">
            <FaGlobe className="fr-title-icon" />
            École - Université française
          </h1>
          <p className="fr-school-subtitle">
            Nous aidons les établissements français à <span className="fr-school-highlight">renforcer leur attractivité, diversifier leurs promotions et améliorer l'intégration</span> de leurs étudiants internationaux.
          </p>
        </div>

        <div className="fr-services-categories">
          {serviceCategories.map((category, index) => (
            <div 
              key={index} 
              className="fr-service-category"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="fr-category-header">
                <div className="fr-category-icon-wrapper">
                  <div className="fr-category-icon">
                    {category.icon}
                  </div>
                </div>
                <h3 className="fr-category-title">
                  {category.title}
                  {category.description.includes('PREMIUM') && (
                    <span className="fr-premium-badge">
                      <FaCrown className="fr-crown-icon" />
                      PREMIUM
                    </span>
                  )}
                </h3>
              </div>
              
              <p className="fr-category-description">{category.description}</p>
              
              <ul className="fr-service-items">
                {category.services.map((service, idx) => (
                  <li key={idx} className="fr-service-item">
                    <span className="fr-service-item-icon">
                      {service.icon}
                    </span>
                    <p className="fr-service-item-text">
                      {service.text}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="fr-objective-container">
          <h3 className="fr-objective-heading">
            <FaBullseye className="fr-objective-icon" />
            Notre Objectif
          </h3>
          <p className="fr-objective-description">
            Recruter à l'international, faciliter la réussite académique et sociale des étudiants étrangers, 
            réduire les risques d'abandon, renforcer la satisfaction étudiante et valoriser la réputation de l'école.
          </p>
        </div>

        <div className="fr-contact-container">
          <h2 className="fr-contact-heading">
            <FaComments className="fr-contact-icon" />
            Contactez nos experts
          </h2>
          <div className="fr-contact-buttons">
            {contacts.map((contact, index) => (
              <div key={index} className="fr-contact-card">
                <div className="fr-contact-card-icon">
                  {contact.icon}
                </div>
                <h3 className="fr-contact-name">{contact.name}</h3>
                <p className="fr-contact-role">{contact.role}</p>
                <a
                  href={createWhatsAppLink(contact.phone, contact.name)}
                  className="fr-whatsapp-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="fr-whatsapp-button-icon">
                    <FiMessageCircle />
                  </span>
                  WhatsApp: {contact.phone}
                </a>
              </div>
            ))}
          </div>
          <p className="fr-contact-note">
            <FaPhoneAlt className="fr-phone-icon" />
            Cliquez sur un bouton pour directement laisser un message sur WhatsApp
          </p>
        </div>
      </div>

    </section>
           <Footer />
    </section>
  );
};

export default EcoleUnivFrancaise;